import React from 'react';
import { Text } from 'react-native';
import PropTypes from 'prop-types';
import { t } from 'Locale';
import LinearGradient from 'react-native-linear-gradient';
import { Button } from 'LocalGluons';
import FreeSpaceIndicator from '../FreeSpaceIndicator';
import { MAX_USED_RECORDING_SPACE } from '../../../../../options';
import styles from './BuyStorageEditButtonsBar.jss';

const buttonStyle = { button: styles.editButton };

const BuyStorageEditButtonsBar = ({
    usedSpace,
    isEditing,
    editedIds,
    stopEditing,
    deleteSelected,
    buyMoreData
}) => (
    <>
        {usedSpace > MAX_USED_RECORDING_SPACE && !isEditing && buyMoreData !== null && (
            <LinearGradient
                style={styles.buyMoreSpaceContainer}
                colors={['#00000055', '#000000FF']}
            >
                <Text style={styles.buyMoreSpaceLink} onPress={buyMoreData}>
                    {t('RECORDINGS.BUY_STORAGE')}
                </Text>
            </LinearGradient>
        )}
        {isEditing && (
            <LinearGradient style={styles.editButtonContainer} colors={['#00000088', '#000000FF']}>
                <Button
                    style={buttonStyle}
                    title={t('RECORDINGS.TO_CANCEL')}
                    onPress={stopEditing}
                    isSecondary
                    testID="cancel_button"
                />
                <Button
                    style={buttonStyle}
                    title={t('COMMON.DELETE')}
                    onPress={deleteSelected}
                    isDisabled={!editedIds.length}
                    testID="delete_button"
                />
            </LinearGradient>
        )}
        {!isEditing && usedSpace >= 0 && <FreeSpaceIndicator usedSpace={usedSpace} />}
    </>
);

BuyStorageEditButtonsBar.defaultProps = {
    usedSpace: -1,
    buyMoreData: null
};

BuyStorageEditButtonsBar.propTypes = {
    usedSpace: PropTypes.number,
    buyMoreData: PropTypes.func,
    editedIds: PropTypes.arrayOf(PropTypes.string).isRequired,
    isEditing: PropTypes.bool.isRequired,
    stopEditing: PropTypes.func.isRequired,
    deleteSelected: PropTypes.func.isRequired
};

export default BuyStorageEditButtonsBar;
